import './responsive.css';
import './i18n';
import './config/setupMonacoLoader';
import { App as AntApp } from 'antd';
import ReactDOM from 'react-dom/client';
import { App } from './Components/app/App';
import React, { Suspense } from 'react';
import * as serviceWorker from './serviceWorker';
import { cssVariablesWithTemplates } from './theme';
import { BrandProvider } from './theme/BrandProvider';
import {
  chainResolvers,
  DEFAULT_TEMPLATE,
  envDefaultResolver,
  platformBrandResolver,
  staticResolver,
} from './theme/BrandResolver';
import config from './config';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import { registerSuperProperties } from './utils/analytics';
import { createLogger } from './utils/logger';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY?.trim();
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST?.trim() ?? 'https://us.i.posthog.com';
const logger = createLogger('bootstrap');

if (POSTHOG_KEY) {
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      // A single-page app: one pageview per route change, and a pageleave on the way out.
      capture_pageview: 'history_change',
      capture_pageleave: 'if_capture_pageview',
      // Front-end errors (error tracking) and Core Web Vitals (LCP, INP, CLS).
      capture_exceptions: true,
      capture_performance: { web_vitals: true },
      // Where people click, and where they click in vain or in frustration.
      enable_heatmaps: true,
      capture_dead_clicks: true,
      rageclick: true,
      // Session replay runs only if the project turns it on (and samples it there). The app shows
      // customers' conversations and data, so every input and every text is masked: a replay
      // shows the layout and the clicks, never the content (CIB-1324).
      session_recording: { maskAllInputs: true, maskTextSelector: '*' },
    });
    // Register synchronously, so app_version / surface / env ride on every event
    // captured afterwards — including the platform_* ones emitted by @shared/inbox
    // before any user has logged in (IMP-311).
    registerSuperProperties();
  } catch (error) {
    logger.error('PostHog initialization failed — analytics disabled for this session', error);
  }
}

// Add CSS variables to document.
// `cssVariablesWithTemplates` trae ademas los bloques `body.template-*`: sin
// ellos el CSS escrito a mano no repinta al cambiar de marca.
const style = document.createElement('style');
style.innerHTML = cssVariablesWithTemplates;
document.head.appendChild(style);

// La marca la elige un superadmin desde Silia OS (GET /api/platform/brand). Si
// nadie la configuró, decide el deploy (REACT_APP_THEME) y, sin variable, Silia.
// `staticResolver` al final hace que la respuesta del endpoint siempre gane sobre
// la marca guardada de una visita anterior.
const brandResolver = chainResolvers(
  platformBrandResolver(`${config.urls.api}/api/platform/brand`),
  envDefaultResolver,
  staticResolver(DEFAULT_TEMPLATE),
);

const container: any = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <Suspense>
    <PostHogProvider client={posthog}>
      <BrandProvider resolver={brandResolver} configProviderProps={{ modal: { zIndex: 1060 } }}>
        <AntApp component={false}>
          <App />
        </AntApp>
      </BrandProvider>
    </PostHogProvider>
  </Suspense>,
);

serviceWorker.unregister();
